import { render, staticRenderFns } from "./quem-somos.vue?vue&type=template&id=7b529e4d"
import script from "./quem-somos.vue?vue&type=script&lang=js"
export * from "./quem-somos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports